import { FieldErrors, FieldValues } from "react-hook-form";

export function getFirstErrorMessage(errors: FieldErrors): string | undefined {
  const firstError = Object.values(errors).find((err) => err?.message);
  return firstError?.message?.toString();
}

export const getAllErrorMessages = <T extends FieldValues>(
  errors: FieldErrors<T>
): string => {
  const messages: string[] = [];

  const extractMessages = (errorObj: FieldErrors<any>) => {
    Object.values(errorObj).forEach((error) => {
      if (!error) return;

      if ("message" in error && error.message) {
        messages.push(`${error.message.toString()}`);
      }

      // Handle nested fields (e.g. objects, arrays)
      if ("types" in error || "ref" in error) return;

      if (typeof error === "object") {
        extractMessages(error as FieldErrors<any>);
      }
    });
  };

  extractMessages(errors);

  return messages.join("\n\n");
};
